import { render, staticRenderFns } from "./AdminCreateCompany.vue?vue&type=template&id=39ca84aa"
import script from "./AdminCreateCompany.vue?vue&type=script&lang=js"
export * from "./AdminCreateCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports